'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var anySignal = require('any-signal');

function filter(signals) {
  return signals.filter(Boolean);
}

function abortSignal() {
  for (var _len = arguments.length, signals = new Array(_len), _key = 0; _key < _len; _key++) {
    signals[_key] = arguments[_key];
  }

  return anySignal.anySignal(filter(signals));
}

exports.abortSignal = abortSignal;